/**
 * @description Maps a php date format token to an equivalent format token in date_fns
 *
 * @see php Format tokens here https://www.php.net/manual/en/datetime.format.php
 * @see moment Format tokens here https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
 */
export var PHP_TO_MOMENT_FORMAT_TOKEN_MAP = {
    A: 'A',
    a: 'a',
    B: '',
    c: 'YYYY-MM-DD[T]HH:mm:ssZ',
    D: 'ddd',
    d: 'DD',
    e: 'zz',
    F: 'MMMM',
    G: 'H',
    g: 'h',
    H: 'HH',
    h: 'hh',
    I: '',
    i: 'mm',
    j: 'D',
    L: '',
    l: 'dddd',
    M: 'MMM',
    m: 'MM',
    N: 'E',
    n: 'M',
    O: 'ZZ',
    o: 'YYYY',
    P: 'Z',
    r: 'ddd, DD MMM YYYY HH:mm:ss ZZ',
    S: 'o',
    s: 'ss',
    T: 'z',
    t: '',
    U: 'X',
    u: 'SSSSSS',
    v: 'SSS',
    W: 'W',
    w: 'e',
    Y: 'YYYY',
    y: 'YY',
    Z: '',
    z: 'DDD',
};
//# sourceMappingURL=PHP_TO_MOMENT_FORMAT_TOKEN_MAP.js.map